import React from "react";
import { usePayButton } from "@switch/cardpayments";
import Button from "@material-ui/core/Button";
import { useTranslation } from 'react-i18next'
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1)
    }

}));



export default function PayButton() {
    const { buttonType, disabled, formName, label, onClick, visible} = usePayButton();
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const classes = useStyles();

    if (!visible) return

    return (<Button

        variant={disabled ? "contained" : "outlined"}
        style={{
            color: disabled
                ? `${theme.palette.info.main}`
                : `${theme.palette.success.main}`,
            border: "2px solid",
            borderColor: disabled
                ? `${theme.palette.info.main}`
                : `${theme.palette.success.main}`
        }}
        className={classes.button}
        onClick={onClick}
        disabled={disabled}
        type={buttonType}
        form={formName}
    >
        {t(label)}
    </Button>)
}
